import { HttpClient } from '@angular/common/http';
import { Injectable,Output,EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AdmakerService {
  @Output() switchTheme = new EventEmitter();
  @Output() changeStepper = new EventEmitter();
  @Output() orderChange = new EventEmitter();
  @Output() savelocal = new EventEmitter();

  constructor(private http: HttpClient) { }

  getAdGroups() {
    return this.http.get( '/api/AdMaker/AdGroups');
  }

  getAdCFields() {
    return this.http.get( '/api/AdMaker/AdFields');
  }
  getAdParts() {
    return this.http.get( '/api/AdMaker/AdParts');
  }

  getAllAdConfigs() {
    return this.http.get( '/api/AdMaker/AdConfigs');
  }
  saveAd(data) {
    return this.http.post('/api/AdMaker/AdConfigs', data);
  }

  delAdConfigs(id) {
    return this.http.delete('/api/AdMaker/AdConfigs/'+id);
  }

  @Output() delAdconfig = new EventEmitter();

}
